import { voucherTextReplacements } from '@luxuryescapes/contract-svc-promo';

// svc-promo only replaces `{name}`, and svc-translation parses copy as ICU,
// where `<name>` is an unclosed tag and `-` / `.` are invalid in a name.
const fixedReplacementNames = new Set(
  voucherTextReplacements.map(({ name }) => name).filter((name) => !name.includes('{n}')),
);
const angleBracketReplacementPattern = /<([A-Za-z0-9_.-]+)>/g;
const rewardReplacementPattern = /^reward(\d+)[-._]([a-z_]+)$/;
const separatedRewardReplacementPattern = /\{(reward\d+)[-.]([a-z_]+)\}/;

const toCurlyReplacement = (name: string): string | null => {
  const reward = rewardReplacementPattern.exec(name);
  if (reward) {
    return `{reward${reward[1]}_${reward[2]}}`;
  }
  return fixedReplacementNames.has(name) ? `{${name}}` : null;
};

export function getVoucherTextReplacementError(value: string | null | undefined): string | null {
  if (!value) {
    return null;
  }

  for (const [token, name] of value.matchAll(angleBracketReplacementPattern)) {
    const replacement = toCurlyReplacement(name);
    if (replacement) {
      return `Use ${replacement} instead of ${token}. Text replacements use curly braces.`;
    }
  }

  const separatedReward = separatedRewardReplacementPattern.exec(value);
  if (separatedReward) {
    return `Use {${separatedReward[1]}_${separatedReward[2]}} instead of ${separatedReward[0]}. Reward text replacements use underscores.`;
  }

  return null;
}

export function validateVoucherTextReplacements(value: string | null | undefined): true | string {
  return getVoucherTextReplacementError(value) ?? true;
}
